import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "med-school-calculator" */ './MedSchoolCalculator'));
